import { Point } from 'app/contracts/Geometry';

/** Calculate the actual position of an element from relative cords (Allowing for offsets) */
export class RelativeTimelinePosition {
	constructor(
		private _relativeX: number,
		private _relativeY: number
	) {}

	private _absoluteX: number;
	private _absoluteY: number;
	private _x: number;
	private _y: number;

	public get x(): number {
		return this._x;
	}

	public get y(): number {
		return this._y;
	}

	public get absoluteX(): number {
		return this._absoluteX;
	}

	public get absoluteY(): number {
		return this._absoluteY;
	}

	public get relativePosition(): any {
		return {
			x: this._relativeX,
			y: this._relativeY
		};
	}

	public resize(containerWidth: number, containerHeight: number) {
		this._absoluteX = containerWidth * this._relativeX;
		this._absoluteY = containerHeight * this._relativeY;
	}

	public update(offsetX: number, offsetY: number): void {
		this._x = this._absoluteX + offsetX;
		this._y = this._absoluteY + offsetY;
	}

	public increase(x: number, y: number): void {
		this._x += x;
		this._y += y;
	}

	public setPosition(point: Point): void {
		this._x = point.x;
		this._y = point.y;
	}

	public setRelativePosition(point: Point): void {
		this._relativeX = point.x;
		this._relativeY = point.y;
	}
}
